import PropTypes from "prop-types";
import IconArrow from "../../../public/images/arrow-down-mini.svg";
import IconForms from "../../../public/images/forms.svg";
import IconCircleField from "../../../public/images/circle-field.svg";
import IconSquareField from "../../../public/images/square-field.svg";
import IconCross from "../../../public/images/close.svg";
import IconCheckmark from "../../../public/images/checkmark-2.svg";
import IconDot from "../../../public/images/dot.svg";
import IconInputField from "../../../public/images/input-field.svg";
import { useTranslation } from "next-i18next";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";

const FormSelect = ({ selectForms }) => {
  const store = useEditorPanelButtonStore();
  const { t } = useTranslation();

  return (
    <div className="select__block">
      <button className="select" onClick={() => {
        store.setIsOpenModal(store.isOpenModal === 'form' ? '' : 'form');
      }}>
        <div className="select__button-text">
          <IconForms className="select__icon" />
          <span>{t(`convert-and-edit:editor.forms`)}</span>
        </div>
        <IconArrow className={`select__icon-arrow ${store.isOpenModal === 'form' ? "select__icon-arrow-active" : ''}`} />
      </button>
      <div className={`block-select__list block-select__form-list select__list ${store.isOpenModal !== 'form' ? "select__list-hide" : ""}`}>
        <div className='block-select__item'>
          <span className='block-select__text'>Fill non-interactive forms</span>
          <div className="block-select__icons">
            <button className='block-select__button-icon' onClick={(event) => selectForms(event, '../images/close.svg')}>
              <IconCross className='block-select__icon' />
            </button>
            <button className='block-select__button-icon' onClick={(event) => selectForms(event, '../images/checkmark-2.svg')}>
              <IconCheckmark className='block-select__icon' />
            </button>
            <button className='block-select__button-icon' onClick={(event) => selectForms(event, '../images/dot.svg')}>
              <IconDot className='block-select__icon' />
            </button>
          </div>
        </div>
        <div className='block-select__item'>
          <span className='block-select__text'>Add new form fields</span>
          <div className="block-select__icons">
            <button className='block-select__button-icon' onClick={(event) => selectForms(event, '../images/input-field.svg')}>
              <IconInputField className='block-select__icon' />
            </button>
            <button className='block-select__button-icon' onClick={(event) => selectForms(event, '../images/square-field.svg')}>
              <IconSquareField className='block-select__icon' />
            </button>
            <button className='block-select__button-icon' onClick={(event) => selectForms(event, '../images/circle-field.svg')}>
              <IconCircleField className='block-select__icon' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

FormSelect.propTypes = {
  selectForms: PropTypes.func.isRequired,
}

export default FormSelect;
